import SkeletonTable from "@/components/SkeletonTable"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import { useQuery } from "@tanstack/react-query"
import { getListKomponenPenilaian } from "@/services/getData"

export default function MasterKomponenPenilaianPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listKomponenPenilaian"],
    queryFn: getListKomponenPenilaian,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
